// @flow

// Types
import type {
  GetTokenSaga,
  GetFetchOptions,
  Get,
  Post,
  Put,
  Delete,
} from '../types'

// Composers
import composeGetFetchOptions from './composers/getFetchOptions'
import composeGet from './composers/__get'
import composePost from './composers/__post'
import composePut from './composers/__put'
import composeDelete from './composers/__delete'

type ComposeFetchArgs = {
  getTokenSaga: GetTokenSaga,
  getUrl: (args: { path: string, id?: number }) => string,
}

type Fetch = {
  __get: Get,
  __post: Post,
  __put: Put,
  __delete: Delete,
}
export default function composeFetch ({
  getTokenSaga,
  getUrl,
  }: ComposeFetchArgs): Fetch {
  const getFetchOptions: GetFetchOptions = composeGetFetchOptions({getTokenSaga})
  const __get = composeGet({ getFetchOptions, getUrl })
  const __post = composePost({ getFetchOptions, getUrl })
  const __put = composePut({ getFetchOptions, getUrl })
  const __delete = composeDelete({ getFetchOptions, getUrl })

  return {
    __get,
    __post,
    __put,
    __delete,
  }
}
